app.directive('programEditorRoot', function ($compile) {
    return {
        restrict: 'A',
        scope: {
            model: '=programEditorRoot'
        },
        transclude: true,
        terminal: true,
        link: function ($scope, $element, $attrs, $ctrls, $transclude) {
            $transclude($scope.$new(true), function (clone, childScope) {
                $element.append(clone);

                childScope.programEditorRoot = {
                    'activeWeek': 0
                };

                $scope.$watch('model', function (newValue) {
                    if (!angular.isObject(newValue)) {
                        // noinspection JSValidateTypes
                        newValue = {'weeks': []};
                    }

                    if (!angular.isArray(newValue.weeks)) {
                        newValue.weeks = [];
                    }

                    childScope.programEditorRoot.model = newValue;
                });

                childScope.programEditorRoot.setActiveWeek = function (activeWeek, $event) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    childScope.programEditorRoot.activeWeek = activeWeek;
                };

                childScope.programEditorRoot.addNewWeek = function ($event) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    childScope.programEditorRoot.model.weeks.push({'days': []});
                    childScope.programEditorRoot.activeWeek = childScope.programEditorRoot.model.weeks.length - 1;
                };

                childScope.programEditorRoot.cloneCurrentWeek = function ($event) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    var clone = angular.copy(childScope.programEditorRoot.model.weeks[childScope.programEditorRoot.activeWeek]);
                    childScope.programEditorRoot.model.weeks.push(clone);
                    childScope.programEditorRoot.activeWeek = childScope.programEditorRoot.model.weeks.length - 1;
                };

                childScope.programEditorRoot.deleteCurrentWeek = function ($event) {
                    if ($event) {
                        $event.preventDefault();
                    }

                    var currentWeeks = childScope.programEditorRoot.model.weeks;
                    var filteredWeeks = [];

                    for (var i = 0; i < currentWeeks.length; i++) {
                        if (i === childScope.programEditorRoot.activeWeek) continue;
                        filteredWeeks.push(currentWeeks[i]);
                    }

                    childScope.programEditorRoot.model.weeks = filteredWeeks;
                    while (childScope.programEditorRoot.activeWeek >= childScope.programEditorRoot.model.weeks.length && childScope.programEditorRoot.activeWeek !== 0) {
                        childScope.programEditorRoot.activeWeek--;
                    }
                };

                childScope.$watch('programEditorRoot.model.weeks.length', function (newValue) {
                    if (newValue === 0) {
                        childScope.programEditorRoot.addNewWeek();
                    }
                });

                childScope.$watch('programEditorRoot.activeWeek', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        childScope.$broadcast('programEditorRoot.activeWeekChanged');
                    }
                });
            });
        }
    };
});